/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing DnsPolicy components.
 * @preferred
 * @module DnsPolicyModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from 'ng/shared/shared.module';
import { DataGridModule } from 'ng/modules/data-grid/data-grid.module';

import {
    DnsPolicyListComponent,
} from './components';

import {
    dnsPolicyCollectionProvider,
    gslbCollectionProvider,
    stringGroupCollectionProvider,
} from './ajs-upgrade-providers';

const dnsPolicyComponents = [
    DnsPolicyListComponent,
];

@NgModule({
    declarations: [
        ...dnsPolicyComponents,
    ],
    imports: [
        CommonModule,
        SharedModule,
        DataGridModule,
    ],
    providers: [
        dnsPolicyCollectionProvider,
        stringGroupCollectionProvider,
        gslbCollectionProvider,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DnsPolicyModule { }
